<template>
    <div>
        <gofix-card fullContent :title="renderTitle" :class="{'boxExpire': isExpire}">
            <template slot="gofixCard:right_header">
                <button class="icon-button mr-3" v-if="isEdit" @click="editApprovalRoute"><img height="20" src="img/iconPencil.png" alt="Delete"></button>
                <button class="icon-button" v-if="isDelete" @click="deleteTableItemsComfirm"><img height="20" src="img/deleteIcon.png" alt="Delete"></button>
            </template>
            <gofix-default-table class="noFullHeight scrollAbsolute"
                                 :settings="tableConfig"
                                 :table-items="tableItems"
                                 @load-items="getTableData"
                                 @delete-items="deleteItems"
                                 @new-item="openCreateApproval"
                                 @row-click="openEditApproval"
                                 ref="gofixTable">
                <template slot="gofix_table:finance_limit" slot-scope="row">
                    {{ row.item.finance_limit | formatMoney }}
                </template>
                <template slot="gofix_table:before-control-right">
                    <template v-if="!isSContract">
                        <template v-if="!isExpire">
                            <div class="tableSendSelected mr-4" v-if="!approvalItem.parent_id">
                                <gofix-button label="SELECT TEMPLATE" @click="openTemplateModal" outline></gofix-button>
                            </div>
                        </template>

                        <div class="mr-4 approval-parent-template-name" v-if="approvalItem.parent_id">{{approvalItem.approval_template ? approvalItem.approval_template.name : null}}</div>
                        <template v-if="!isExpire">
                            <div class="mr-4" v-if="approvalItem.parent_id">
                                <gofix-button label="CHANGE TEMPLATE" @click="openTemplateModal" outline></gofix-button>
                            </div>
                            <div class="mr-4" v-if="approvalItem.parent_id">
                                <gofix-button label="SAVE SEQUENCE" @click="saveSequence"></gofix-button>
                            </div>
                        </template>
                    </template>
                </template>

                <template slot="gofix_table:before-actions"  slot-scope="row">
                    <div class="sortSequence">
                        <span class="up no-edit" @click="upSequence(row.item)"><img src="img/arrow-up.png" alt=""></span>
                        <span class="down no-edit" @click="downSequence(row.item)"><img src="img/arrow-down.png" alt=""></span>
                    </div>
                </template>
            </gofix-default-table>
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="modals.delete.open">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.delete.open = false">No</b-button>
                <b-button class="custom-btn" @click="deleteTemplate" :disabled="modals.delete.loading">
                    <b-spinner v-if="modals.delete.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 modal-class="default-modal"
                 :title="modals.template.title"
                 hide-footer :centered="true"
                 v-model="modals.template.open">
            <b-form class="pb-20">
                <gofix-form-dropdown
                        label="Template"
                        :options="modals.template.templates"
                        vLabel="name"
                        :reduce="option => option.id"
                        v-model="modals.template.data.parent_id">
                </gofix-form-dropdown>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT & NEW VERSION" @click="updateTemplate(true)" :loading="modals.template.loadingNewVersion" noBorder></gofix-button>
                <gofix-button label="SUBMIT" @click="updateTemplate(false)" :loading="modals.template.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.createApproval.title"  hide-footer :centered="true" v-model="modals.createApproval.open">
            <div class="" v-bind:class="{'run-loading':modals.createApproval.loading}">
                <b-form class="pb-20">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-dropdown
                                    :multiple="true"
                                    label="Roles"
                                    :options="modals.createApproval.roles"
                                    vLabel="name"
                                    v-model="modals.createApproval.data.roles">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input-number 
                                    label="Financial Limit" 
                                    v-model="modals.createApproval.data.finance_limit"
                                    prefix="$" required></gofix-form-input-number>
                        </b-col>
                    </b-row>
                </b-form>

                <b-button-group class="d-block text-right">
                    <!-- <gofix-button label="SAVE & NEW VERSION" :loading="modals.createApproval.loadingNewVersion" @click="saveApproval(true)" noBorder></gofix-button> -->
                    <gofix-button label="SAVE" :loading="modals.createApproval.loading" @click="saveApproval(false)" noBorder></gofix-button>
                </b-button-group>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.deleteNewVersion.open">
            <div class="center">Do you want to create new <strong>route</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" :disabled="modals.deleteNewVersion.loadingNo" @click="deleteAndNewVersion(false)"><b-spinner v-if="modals.deleteNewVersion.loadingNo" small type="grow"></b-spinner> No</b-button>
                <b-button class="custom-btn" :disabled="modals.deleteNewVersion.loadingYes" @click="deleteAndNewVersion(true)"> <b-spinner v-if="modals.deleteNewVersion.loadingYes" small type="grow"></b-spinner> Yes</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    import moment from 'moment';
    export default {
        name: 'approval',
        props:{
            approvalItem: {
                type: Object,
                required: true,
                default: () => {}
            },
            isSContract: {
                type: Boolean,
                default: false
            }
        },
        components: {

        },
        data () {
            let filter = JSON.parse(JSON.stringify(filters['approval_route']));
            return {
                tableConfig:{
                    name: 'client-contract-approval-route',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    sortColumn: "sequence",
                    sortDirection: "asc",
                },
                tableItems: [],
                modals:{
                    delete: {
                        open: false,
                        loading: false,
                    },
                    template:{
                        open:false,
                        loading:false,
                        loadingNewVersion: false,
                        title: this.approvalItem.parent_id ? "Change Template" : "Select Template",
                        data:{
                            parent_id : this.approvalItem.parent_id
                        },
                        templates:[]
                    },
                    createApproval:{
                        title: "Add approval",
                        open: false,
                        loading: false,
                        loadingNewVersion: false,
                        data: {
                            id: null,
                            roles: null,
                            finance_limit: null,
                            approval_template_id: null
                        },
                        roles:[]
                    },
                    deleteNewVersion: {
                        open: false,
                        loadingYes: false,
                        loadingNo: false,
                        ids: [],
                    }
                }
            }
        },
        computed: {
            renderTitle() {
                let title = (this.approvalItem.approval_process ? this.approvalItem.approval_process.reference_value_text : '') + ' - ' + (this.approvalItem.location ? this.approvalItem.location.name : '')
                if(this.approvalItem.effective_date) title += ` (${moment(this.approvalItem.effective_date).format("DD.MM.YYYY")})`;
                if(this.approvalItem.is_current) title += ` - Active`;
                return title;
            },
            isEdit() {
                // if(this.approvalItem && !this.approvalItem.is_current && this.approvalItem.effective_date && moment().isSameOrBefore(moment(this.approvalItem.effective_date))) return true
                if(
                    this.approvalItem && 
                    (
                        (!this.approvalItem.is_current && this.approvalItem.effective_date && moment().isSameOrBefore(moment(this.approvalItem.effective_date))) ||
                        (this.approvalItem.is_current && this.approvalItem.is_allow_delete)
                    )
                ) return true;
                return false;
            },
            isDelete() {
                return this.approvalItem.is_allow_delete;
            },
            isExpire() {
                if(this.approvalItem && !this.approvalItem.is_current && this.approvalItem.effective_date && moment().isSameOrAfter(moment(this.approvalItem.effective_date))) return true
                return false;
            }
        },
        created() {
            this.getTemplate();
            this.getFmRoles();
            
            this.tableConfig.controls = {
                create: this.isEdit,
                delete: this.isDelete,
                tableImport: false,
                tableExport: false
            }
        },
        methods:{
            deleteTableItemsComfirm(){
                this.modals.delete.open = true;
            },
            deleteTemplate(){
                if(this.modals.delete.loading) return;
                this.modals.delete.loading = true;

                let ids = [this.approvalItem.id];
                this.$store.dispatch("ApprovalTemplateController/deleteItems", ids)
                    .then(async response => {
                        this.modals.delete.open = false;
                        this.modals.delete.loading = false;
                        await this.$emit("reload-list");
                        await this.$alertNotification(this.$notificationV2('deleting', 'approval_template'));
                    })
                    .catch(err => {
                        this.modals.delete.loading = false;
                    });
            },
            getTemplate(){
                let requestData = {
                    limit: -1,
                    page: 1,
                    filter: {
                        name_not_null : true
                    }
                };
                this.$store.dispatch("ApprovalTemplateController/getItems", requestData)
                    .then(response => {
                        this.modals.template.templates = response.items;
                    })
                    .catch(err => {
                        console.log(err)
                    });
            },
            openTemplateModal(){
                this.modals.template.data.parent_id = this.approvalItem ? this.approvalItem.parent_id : null;
                this.modals.template.title = this.modals.template.data.parent_id ? "Change Template" : "Select Template";
                this.modals.template.open = true;
            },
            updateTemplate(is_new_version){
                if(!this.modals.template.data.parent_id){
                    return this.$alertNotification("Please select a template", "danger");
                }
                if(this.modals.template.loading || this.modals.template.loadingNewVersion) return;
                if(is_new_version) this.modals.template.loadingNewVersion = true;
                else this.modals.template.loading = true;

                let data = {
                    id: this.approvalItem.id,
                    parent_id: this.modals.template.data.parent_id,
                    reload_entry: true
                }

                if(is_new_version) data.is_new_version = true;
                this.$store.dispatch("ApprovalTemplateController/updateItem", data)
                    .then(response => {
                        this.modals.template.loading = false;
                        this.modals.template.loadingNewVersion = false;
                        this.modals.template.open = false;
                        this.$refs.gofixTable.reloadTableItems();
                        this.$emit("reload-list");
                    })
                    .catch(err => {
                        this.modals.template.loading = false;
                        this.modals.template.loadingNewVersion = false;
                    });
            },

            /*Entry*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                if(!this.approvalItem.id){
                    this.tableItems = [];
                    this.tableConfig.total = 0;
                    resolve({
                        items: [],
                        total: 0
                    });
                    return;
                }
                tableRequest.filter.approval_template_id.value = this.approvalItem ? this.approvalItem.id : 0;
                await this.$store.dispatch("ApprovalController/getApprovalItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids, resolve } = await callback();
                this.modals.deleteNewVersion.ids = ids;
                this.modals.deleteNewVersion.open = true;
                resolve();
            },
            deleteAndNewVersion(is_new_version) {
                if(is_new_version) this.modals.deleteNewVersion.loadingYes = true;
                else this.modals.deleteNewVersion.loadingNo = true;
                this.$store.dispatch('ApprovalController/deleteApproval', {
                    ids: this.modals.deleteNewVersion.ids,
                    approval_template_id :this.approvalItem.id,
                    is_new_version: is_new_version
                }).then(response => {
                    this.modals.deleteNewVersion.loadingNo  = false;
                    this.modals.deleteNewVersion.loadingYes = false;
                    this.modals.deleteNewVersion.open = false;
                    if(is_new_version) this.$emit("reload-list");
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.$alertNotification(this.$notificationV2('deleting', 'approval'));
                })
                .catch(err => {
                    this.modals.deleteNewVersion.loadingNo  = false;
                    this.modals.deleteNewVersion.loadingYes = false;
                })
            },
            saveApproval(is_new_version = false) {
                let approvalObject = Object.assign({}, this.modals.createApproval.data);
                if (!approvalObject.finance_limit) {
                    approvalObject.finance_limit = 0;
                }else{
                    approvalObject.finance_limit = this.$accounting.unformat(approvalObject.finance_limit)
                }
                if (!approvalObject.roles) {
                    return this.$alertNotification("Role is a required field.", "danger");
                }
                
                // approvalObject.role_id = approvalObject.role.id;
                // delete approvalObject.role;
                approvalObject.contract_id = this.$route.params.id;
                approvalObject.roles = approvalObject.roles.map(item => item.id);

                if(this.modals.createApproval.loading || this.modals.createApproval.loadingNewVersion) return;
                if(is_new_version) this.modals.createApproval.loadingNewVersion = true;
                else this.modals.createApproval.loading = true;

                if(!approvalObject.id) {
                    this.$store.dispatch('ApprovalController/createApproval', approvalObject)
                        .then(result => {
                            this.$alertNotification(this.$notificationV2('adding', 'approval'));
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.modals.createApproval.loading = false;
                            this.modals.createApproval.loadingNewVersion = false;
                            this.modals.createApproval.open = false;
                        })
                        .catch(err => {
                            this.$alertNotification("Sorry, Approval can't create now. Please try again later", "danger");
                            this.modals.createApproval.loading = false;
                            this.modals.createApproval.loadingNewVersion = false;
                        })
                }else{
                    let api = 'updateApproval';
                    if(is_new_version) api = 'updateAndNewApproval';
                    this.$store.dispatch(`ApprovalController/${api}`, approvalObject)
                        .then(result => {
                            this.$alertNotification(this.$notificationV2('editing', 'approval'));
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.modals.createApproval.loading = false;
                            this.modals.createApproval.loadingNewVersion = false;
                            this.modals.createApproval.open = false;
                        })
                        .catch(err => {
                            this.$alertNotification("Sorry, Approval can't update now. Please try again later", "danger");
                            this.modals.createApproval.loading = false;
                            this.modals.createApproval.loadingNewVersion = false;
                        })
                }
            },

            getFmRoles(){
                this.$store.dispatch("RoleController/getRoleItems",{
                    filter:{
                        group_tags: !this.isSContract ? "FM" : "Supplier"
                    }
                })
                    .then(response => {
                        this.modals.createApproval.roles = response.items;
                    });
            },
            upSequence(item){
                let arr = JSON.parse(JSON.stringify(this.tableItems));
                let order_number = item.sequence
                let prev_item = arr[order_number - 2]
                if((prev_item && prev_item.finance_limit) !== item.finance_limit){
                    return
                }
                prev_item.sequence = order_number;
                arr[order_number - 1] = prev_item;
                item.sequence = order_number - 1
                arr[order_number - 2] = item;
                this.tableItems = JSON.parse(JSON.stringify(arr));
            },
            downSequence(item){
                let arr = JSON.parse(JSON.stringify(this.tableItems));
                let order_number = item.sequence
                let next_item = arr[order_number]
                if((next_item && next_item.finance_limit) !== item.finance_limit){
                    return
                }
                next_item.sequence = order_number;
                arr[order_number - 1] = next_item;
                item.sequence = order_number + 1
                arr[order_number] = item;
                this.tableItems = JSON.parse(JSON.stringify(arr));
            },
            saveSequence(){
                let params = this.tableItems.map((x, index) => {
                    return {id: x.id, level: index + 1}
                });
                this.$store.dispatch("ApprovalController/saveSequence", {sequence: JSON.stringify(params)})
                    .then(response => {
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification("success");
                    });
            },
            openCreateApproval(){
                this.modals.createApproval.title = "Add approval";
                this.modals.createApproval.data = {
                    id : null,
                    role: null,
                    finance_limit: null,
                    approval_template_id: this.approvalItem.id
                };
                this.modals.createApproval.open = true;
            },
            openEditApproval(item){
                if(!this.isEdit) return;
                this.modals.createApproval.title = "Edit approval";
                this.modals.createApproval.data = {
                    id : item.id,
                    roles: item.roles,
                    finance_limit: this.$accounting.formatMoney(item.finance_limit),
                    approval_template_id: item.approval_template_id
                };
                this.modals.createApproval.open = true;
            },
            editApprovalRoute() {
                this.$emit('edit-template', this.approvalItem);
            }
        }
    }
</script>
